import subTitle from "@/modules/pengaturan-umum/store/state";
import reminder from "@/modules/pengaturan-umum/store/state";
import epayment from "@/modules/pengaturan-umum/store/state";

const mutations = {
  setSubMenu: (state, payload) => {
    state.subMenu = payload;
  },
  setSubTitle: (state, { menu, data }) => {
    if (menu === "epayment") {
      state.subTitle.epayment = {
        masaAktif: `${data.masa_aktif_emoney} hari`,
        tipe: data.label.tipe_perpanjangan_masa_aktif_emoney,
        JikaKedaluwarsa: data.label.tipe_saldo_expired_emoney,
        jenisEmoney: data.jenis_emoney,
      };
    }
    if (menu == 'pelunasanInvoice') {
      let text
      switch (data.bisa_lunasi_invoice) {
        case 0:
          text = '<i>Belum diatur</i>'
          break;
        case 1:
          text = '<i>Diatur sebagian & semua</i>'
          break;
        case 2:
          text = '<i>Diatur sebagian</i>'
          break;
        default:
          break;
      }
      state.subTitle.pelunasanInvoice = {
        pengaturanKasir: text
      }
    }
  },
  setFetching: (state, payload) => {
    state.fetching = payload;
  },
  setResponse: (state, payload) => {
    state.response = payload;
  },
  setEpayment: (
    state,
    { jenis_emoney, masa_aktif_emoney, tipe_perpanjangan_masa_aktif_emoney, tipe_saldo_expired_emoney }
  ) => {
    state.epayment = {
      jenis_emoney,
      masa_aktif_emoney,
      tipe_perpanjangan_masa_aktif_emoney,
      tipe_saldo_expired_emoney,
    };
  },
  updateEpayment: (state, { key, val }) => {
    state.epayment[key] = val;
  },
  setPenyesuaian: (state, data) => {
    state.penyesuaian = data
  },

  setReminderOption: (state, data) => {
    state.reminderOption = data
  },
  setReminderInfo: (state, res) => {
    state.reminderInfo = res
    state.subTitle.reminder.deposit = res.reminder_deposit_label
    state.subTitle.reminder.epayment = res.reminder_emoney_label
    state.subTitle.reminder.poin = res.reminder_poin_label
  },
  setSumberDana: (state, payload) => {
    state.pengaturanLaporan.sumberDana = payload;
  },
  setItemBiaya: (state, payload) => {
    state.pengaturanLaporan.itemBiaya = payload;
  },
  setCustomerAmbilDanLunasi: (state, data) => {
    state.customerAmbilDanLunasi = data
  },
  setPelunasanInvoice: (state, data) => {
    state.pelunasanInvoice = data
  },
  setWaNotaSetting: (state, data) => {
    state.notaWaSetting = data
  },
  setEnableWaVerification: (state, data) => {
    state.enableWaVerification = data
  },
  setCashbackActivePeriod: (state, data) => {
    state.cashbackActivePeriod = data
  },
	setPointActivePeriod: (state, data) => {
    state.pointActivePeriod = data
  },
  setPointActiveReminder: (state, data) => {
    state.pointActiveReminder = data
  },
  setEnableServiceRecommendation: (state, data) => {
    state.enableServiceRecommendation = data
  },
};

export default mutations;
